module.exports = __webpack_public_path__ + "media/images/icon_company_badge1-ced1bccc2ef0b7b3273b5c4fa2260fc5.svg";